const ITEMS_PER_PAGE = 64;
let visibleCount = ITEMS_PER_PAGE;
let loadMoreContainer = null;
let loadMoreButton = null;

async function fetchPage(collectionHandle, page) {
  try {
    const res = await fetch(`/collections/${collectionHandle}/all-products?page=${page}`);
    const html = await res.text();
    return html.includes('gallery__grid_item') ? html : null;
  } catch (error) {
    console.error('Error fetching page ' + page + ':', error);
    return null;
  }
}

async function fetchAllProductsFromCollection(collectionHandle) {
  let allHTML = '';
  let page = 1;
  let hasMore = true;

  while (hasMore) {
    const batch = [];
    for (let i = 0; i < 4; i++) {
      batch.push(fetchPage(collectionHandle, page + i));
    }
    const results = await Promise.all(batch);
    let gotResults = false;
    for (const html of results) {
      if (html) {
        allHTML += html;
        gotResults = true;
      }
    }
    if (!gotResults) {
      hasMore = false;
    } else {
      page += 4;
    }
  }

  return allHTML;
}

function renderGallery(products) {
  const container = document.querySelector('.gallery__grid');
  if (!container) return;
  container.insertAdjacentHTML('beforeend', products);
}

function createLoadMoreButton() {
  const gallery = document.querySelector('.gallery__grid');
  if (!gallery) return;

  loadMoreContainer = document.createElement('div');
  loadMoreContainer.className = 'load-more-container';
  loadMoreButton = document.createElement('button');
  loadMoreButton.className = 'load-more-button';
  loadMoreButton.textContent = 'Load More';
  loadMoreContainer.appendChild(loadMoreButton);
  gallery.parentElement.appendChild(loadMoreContainer);

  loadMoreButton.addEventListener('click', () => {
    visibleCount += ITEMS_PER_PAGE;
    applyLoadMore();
    observeLazyImages();
  });
}

function applyLoadMore() {
  const gallery = document.querySelector('.gallery__grid');
  if (!gallery) return;

  const allItems = gallery.querySelectorAll('.gallery__grid_item');
  let count = 0;
  let totalInGallery = allItems.length;

  allItems.forEach(item => {
    count++;
    if (count <= visibleCount) {
      item.style.display = 'block';
      item.classList.add('visible');
    } else {
      item.style.display = 'none';
      item.classList.remove('visible');
    }
  });

  if (loadMoreContainer) {
    if (visibleCount >= totalInGallery) {
      loadMoreContainer.style.display = 'none';
    } else {
      loadMoreContainer.style.display = 'flex';
    }
  }
}

function hideLoader() {
  const loader = document.querySelector('.loader_container');
  if (loader) {
    loader.style.display = 'none';
  }
}

function initFilter() {
  const gallery = document.querySelector('.gallery__grid');
  let galleryItems = document.querySelectorAll('.gallery__grid_item');
  const modelsGroup = document.getElementById('models');
  const designsGroup = document.getElementById('designs');
  const colorsGroup = document.getElementById('colors');
  const brandsGroup = document.getElementById('brands');
  const selectedFiltersList = document.getElementById('selected-filters-list');
  const resetButton = document.getElementById('reset');

  function ensureFilterDropdownStyles() {
    if (document.getElementById('gallery-filter-dropdown-styles')) return;
    const style = document.createElement('style');
    style.id = 'gallery-filter-dropdown-styles';
    style.textContent = `
      .gallery .checkbox-group.dropdown {
        max-height: 520px;
        max-height: min(64vh, 520px);
        overflow-y: auto;
        overflow-x: hidden;
        box-sizing: border-box;
        max-width: calc(100vw - 24px);
        scrollbar-width: thin;
      }
      .gallery .checkbox-group.dropdown label {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        box-sizing: border-box;
        white-space: nowrap;
      }
      .gallery .checkbox-group.dropdown label input {
        flex: 0 0 auto;
        margin: 0;
      }
      .gallery .checkbox-group.dropdown .filter-label-text {
        flex: 1 1 auto;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .gallery .checkbox-group.dropdown .filter-count {
        flex: 0 0 auto;
        margin-left: auto;
        white-space: nowrap;
        display: inline-block;
      }
    `;
    document.head.appendChild(style);
  }

  ensureFilterDropdownStyles();

  const toggleButtons = document.querySelectorAll('.toggle-button');

  // Toggle dropdowns for filters
  toggleButtons.forEach(button => {
    button.addEventListener('click', () => {
      const targetId = button.dataset.target;
      const dropdown = document.getElementById(targetId);
      if (dropdown.classList.contains('hidden')) {
        dropdown.classList.remove('hidden');
      } else {
        dropdown.classList.add('hidden');
      }
      document.querySelectorAll('.checkbox-group').forEach(group => {
        if (group.id !== button.dataset.target) {
          group.classList.add('hidden');
        }
      });
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.filter-group')) {
      document.querySelectorAll('.checkbox-group').forEach(group => group.classList.add('hidden'));
    }
  });

  const sortValues = (values) => {
    return values
      .filter(Boolean)
      .map(value => value.trim())
      .filter(Boolean)
      .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }));
  };

  const uniqueValues = (attr) => {
    return sortValues([...new Set([...galleryItems].flatMap(item => item.dataset[attr]?.split(',') || []))]);
  };

  const updateLabelCount = (label, count) => {
    const countEl = label.querySelector('.filter-count');
    if (countEl) {
      countEl.textContent = `\u00a0(${count})`;
    }
  };

  const populateCheckboxGroup = (group, values, attr) => {
    group.innerHTML = '';
    const counts = {};
    galleryItems.forEach(item => {
      const itemValues = item.dataset[attr]?.split(',') || [];
      itemValues.map(value => value.trim()).filter(Boolean).forEach(value => {
        counts[value] = (counts[value] || 0) + 1;
      });
    });
    values.forEach(value => {
      const count = counts[value] || 0;
      const label = document.createElement('label');
      const input = document.createElement('input');
      const nameSpan = document.createElement('span');
      const countSpan = document.createElement('span');
      input.type = 'checkbox';
      input.value = value;
      nameSpan.className = 'filter-label-text';
      nameSpan.textContent = ` ${value}`;
      countSpan.className = 'filter-count';
      countSpan.textContent = `\u00a0(${count})`;
      countSpan.style.whiteSpace = 'nowrap';
      countSpan.style.display = 'inline-block';
      label.appendChild(input);
      label.appendChild(nameSpan);
      label.appendChild(countSpan);
      group.appendChild(label);
    });
    group.querySelectorAll('label').forEach(label => {
      label.style.display = '';
    });
  };

  function enforceSingleSelection(group) {
    const inputs = group.querySelectorAll('input');
    inputs.forEach(input => {
      input.addEventListener('change', () => {
        if (input.checked) {
          inputs.forEach(otherInput => {
            if (otherInput !== input) {
              otherInput.checked = false;
            }
          });
          if (group.id === 'brands') {
            modelsGroup.querySelectorAll('input').forEach(modelInput => {
              modelInput.checked = false;
            });
          }
          if (group.id === 'brands' || group.id === 'models') {
            group.classList.add('hidden');
          }
          updateFilters();
        }
      });
    });
  }

  let baseForColors = [];
  let baseForDesigns = [];
  let baseForBrands = [];
  let baseForModels = [];

  const updateCheckboxCounts = () => {
    const relevantItems = [...gallery.querySelectorAll('.gallery__grid_item.relevant')];
    const updateGroup = (group, attr, alwaysVisible = false, countsSource = relevantItems) => {
      const counts = {};
      countsSource.forEach(item => {
        const values = item.dataset[attr]?.split(',') || [];
        values.map(value => value.trim()).filter(Boolean).forEach(value => {
          counts[value] = (counts[value] || 0) + 1;
        });
      });
      group.querySelectorAll('label').forEach(label => {
        const checkbox = label.querySelector('input');
        const count = counts[checkbox.value] || 0;
        updateLabelCount(label, count);
        if (!alwaysVisible && !checkbox.checked) {
          label.style.display = count > 0 ? '' : 'none';
        } else {
          label.style.display = "";
        }
      });
    };

    const selectedFilters = {
      brand: getSelectedValues(brandsGroup),
      model: getSelectedValues(modelsGroup),
      design: getSelectedValues(designsGroup),
      color: getSelectedValues(colorsGroup)
    };
    baseForModels = [...galleryItems].filter(item => {
      const matchesBrand = !selectedFilters.brand.length || selectedFilters.brand.includes(item.dataset.brand);
      const matchesDesign = !selectedFilters.design.length || selectedFilters.design.includes(item.dataset.design);
      const matchesColor = !selectedFilters.color.length || selectedFilters.color.map(c => c.trim().toLowerCase()).includes((item.dataset.color || '').trim().toLowerCase());
      return matchesBrand && matchesDesign && matchesColor;
    });
    updateGroup(modelsGroup, 'cars', false, baseForModels);
    updateGroup(designsGroup, 'design', false, baseForDesigns);
    updateGroup(colorsGroup, 'color', false, baseForColors);
    updateGroup(brandsGroup, 'brand', true, baseForBrands);
  };

  const getSelectedValues = (group) => {
    return [...group.querySelectorAll('input:checked')].map(input => input.value);
  };

  function filterDesigns(selectedBrand, selectedModels) {
    let relevantDesigns = new Set();
    document.querySelectorAll(".gallery__grid_item").forEach(item => {
      let brand = item.getAttribute("data-brand");
      let model = item.getAttribute("data-cars");
      let design = item.getAttribute("data-design");
      let matchesBrand = selectedBrand ? (brand.trim().toLowerCase() === selectedBrand.value.trim().toLowerCase()) : true;
      let matchesModel = selectedModels.length ? Array.from(selectedModels).some(m => model.includes(m.value)) : true;
      if (matchesBrand && matchesModel && design) {
        relevantDesigns.add(design);
      }
    });
    updateCheckboxesForGroup(designsGroup, relevantDesigns, true);
  }

  function filterColors(selectedDesigns) {
    let relevantColors = new Set();
    document.querySelectorAll(".gallery__grid_item").forEach(item => {
      let design = item.getAttribute("data-design");
      let color = item.getAttribute("data-color");
      let matchesDesign = selectedDesigns.some(d => design.trim().toLowerCase().includes(d.value.trim().toLowerCase()));
      if (matchesDesign && color) {
        relevantColors.add(color);
      }
    });
    updateCheckboxesForGroup(colorsGroup, relevantColors, true);
  }

  function updateCheckboxesForGroup(group, relevantSet, disableIfEmpty) {
    group.querySelectorAll("label").forEach(label => {
      const checkbox = label.querySelector("input");
      if (checkbox.checked) {
        label.style.display = "";
        checkbox.disabled = false;
      } else if (relevantSet.has(checkbox.value)) {
        label.style.display = "";
        checkbox.disabled = false;
      } else {
        if (disableIfEmpty) {
          checkbox.disabled = true;
          label.style.display = "none";
        } else {
          label.style.display = "none";
        }
      }
    });
  }

  function updateURL(selectedFilters) {
    let parts = [];
    let noindex = false;
    for (let key in selectedFilters) {
      if (selectedFilters[key].length > 0) {
        let valueStr = selectedFilters[key].map(v => encodeURIComponent(v)).join(',');
        parts.push(`${key}=${valueStr}`);
        if (selectedFilters[key].length > 1) {
          noindex = true;
        }
      }
    }
    let query = parts.join('-');
    if (noindex) {
      query += "-noindex=1";
    }
    let newURL = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + query;
    history.pushState(null, '', newURL);
  }

  function loadFiltersFromURL() {
    let search = window.location.search;
    if (!search) return;
    search = decodeURIComponent(search.substring(1));
    search = search.replace(/-noindex=1/, '');
    let groups = search.split('-');
    let groupMapping = {
      "brand": brandsGroup,
      "model": modelsGroup,
      "design": designsGroup,
      "color": colorsGroup
    };
    groups.forEach(part => {
      let [key, valueStr] = part.split('=');
      if (valueStr) {
        let values = valueStr.split(',');
        let groupEl = groupMapping[key];
        if (groupEl) {
          values.forEach(val => {
            let checkbox = groupEl.querySelector(`input[value="${val}"]`);
            if (checkbox) {
              checkbox.checked = true;
            }
          });
        }
      }
    });
  }

  const updateFilters = () => {
    const selectedFilters = {
      brand: getSelectedValues(brandsGroup),
      model: getSelectedValues(modelsGroup),
      design: getSelectedValues(designsGroup),
      color: getSelectedValues(colorsGroup)
    };

    selectedFiltersList.innerHTML = '';
    Object.entries(selectedFilters).forEach(([key, values]) => {
      values.forEach(value => {
        const filterTag = document.createElement('button');
        filterTag.classList.add('filter-tag');
        filterTag.textContent = `${value} ✕`;
        filterTag.dataset.filterGroup = key;
        filterTag.dataset.filterValue = value;
        filterTag.addEventListener('click', () => {
          removeFilter(key, value);
        });
        selectedFiltersList.appendChild(filterTag);
      });
    });

    const selectedBrandCheckbox = brandsGroup.querySelector("input:checked");
    const selectedModelCheckboxes = modelsGroup.querySelectorAll("input:checked");
    const selectedDesignCheckboxes = designsGroup.querySelectorAll("input:checked");
    const modelsToggleButton = document.querySelector('button[data-target="models"]');
    if (!selectedBrandCheckbox) {
      modelsGroup.querySelectorAll("input").forEach(input => {
        input.checked = false;
        input.disabled = true;
      });
      modelsToggleButton.disabled = true;
      modelsToggleButton.classList.add("disabled");
    } else {
      modelsToggleButton.disabled = false;
      modelsToggleButton.classList.remove("disabled");
      const brandValue = selectedBrandCheckbox.value.trim().toLowerCase();
      let validModels = new Set();
      galleryItems.forEach(item => {
        let itemBrand = item.dataset.brand ? item.dataset.brand.trim().toLowerCase() : "";
        if (itemBrand === brandValue) {
          const modelsStr = item.dataset.cars || "";
          modelsStr.split(',').forEach(m => validModels.add(m.trim().toLowerCase()));
        }
      });
      modelsGroup.querySelectorAll('label').forEach(label => {
        const checkbox = label.querySelector('input');
        if (validModels.has(checkbox.value.trim().toLowerCase())) {
          label.style.display = "";
        } else {
          label.style.display = "none";
        }
      });
    }

    if (selectedBrandCheckbox || selectedModelCheckboxes.length > 0) {
      filterDesigns(selectedBrandCheckbox, Array.from(selectedModelCheckboxes));
    } else {
      designsGroup.querySelectorAll("label").forEach(label => {
        label.style.display = "";
        label.querySelector("input").disabled = false;
      });
    }

    if (selectedDesignCheckboxes.length > 0) {
      filterColors(Array.from(selectedDesignCheckboxes));
    } else {
      colorsGroup.querySelectorAll("label").forEach(label => {
        label.style.display = "";
        label.querySelector("input").disabled = false;
      });
    }

    if (selectedFilters.color.length) {
      baseForDesigns = [...galleryItems].filter(item => {
        const matchesBrand = !selectedFilters.brand.length || selectedFilters.brand.includes(item.dataset.brand);
        const matchesModel = !selectedFilters.model.length || selectedFilters.model.some(model => item.dataset.cars?.split(',').includes(model));
        const matchesColor = selectedFilters.color.map(c => c.trim().toLowerCase()).includes((item.dataset.color || '').trim().toLowerCase());
        return matchesBrand && matchesModel && matchesColor;
      });
    } else {
      baseForDesigns = [...galleryItems].filter(item => {
        const matchesBrand = !selectedFilters.brand.length || selectedFilters.brand.includes(item.dataset.brand);
        const matchesModel = !selectedFilters.model.length || selectedFilters.model.some(model => item.dataset.cars?.split(',').includes(model));
        return matchesBrand && matchesModel;
      });
    }
    baseForColors = [...galleryItems].filter(item => {
      const matchesBrand = !selectedFilters.brand.length || selectedFilters.brand.includes(item.dataset.brand);
      const matchesModel = !selectedFilters.model.length || selectedFilters.model.some(model => item.dataset.cars?.split(',').includes(model));
      const matchesDesign = !selectedFilters.design.length || selectedFilters.design.includes(item.dataset.design);
      return matchesBrand && matchesModel && matchesDesign;
    });
    baseForBrands = [...galleryItems].filter(item => {
      const matchesModel = !selectedFilters.model.length || selectedFilters.model.some(model => item.dataset.cars?.split(',').includes(model));
      const matchesDesign = !selectedFilters.design.length || selectedFilters.design.includes(item.dataset.design);
      const matchesColor = !selectedFilters.color.length || selectedFilters.color.includes(item.dataset.color);
      return matchesModel && matchesDesign && matchesColor;
    });

    const filteredItems = [];
    const unfilteredItems = [];
    galleryItems.forEach(item => {
      const matchesBrand = !selectedFilters.brand.length || selectedFilters.brand.includes(item.dataset.brand);
      const matchesModel = !selectedFilters.model.length || selectedFilters.model.some(model => item.dataset.cars?.split(',').includes(model));
      const matchesDesign = !selectedFilters.design.length || selectedFilters.design.includes(item.dataset.design);
      const matchesColor = !selectedFilters.color.length || selectedFilters.color.map(c => c.trim().toLowerCase()).includes((item.dataset.color || '').trim().toLowerCase());
      let match;
      if (selectedFilters.brand.length || selectedFilters.model.length) {
        match = matchesBrand && matchesModel && matchesDesign && matchesColor;
      } else {
        match = matchesDesign && matchesColor;
      }
      if (match) {
        filteredItems.push(item);
        item.classList.add('relevant');
      } else {
        unfilteredItems.push(item);
        item.classList.remove('relevant');
      }
    });

    let noResultsText = document.getElementById('no-results-text');
    if (!noResultsText) {
      noResultsText = document.createElement('div');
      noResultsText.id = 'no-results-text';
      noResultsText.classList.add('gallery__grid_item--full-width');
      noResultsText.textContent = 'No matching results found. Try adjusting your filters.';
      gallery.parentElement.insertBefore(noResultsText, gallery);
    }
    noResultsText.style.display = filteredItems.length ? 'none' : 'block';

    gallery.innerHTML = '';
    filteredItems.forEach(item => {
      gallery.appendChild(item);
      item.style.display = 'block';
      item.classList.remove('visible');
    });
    if (unfilteredItems.length) {
      const recommendationText = document.createElement('div');
      recommendationText.classList.add('gallery__grid_item--full-width');
      recommendationText.textContent = 'We\u2019ve got more for you to discover!';
      gallery.appendChild(recommendationText);
      unfilteredItems.forEach(item => {
        gallery.appendChild(item);
        item.style.display = 'block';
        item.classList.remove('visible');
      });
    }

    if (selectedFilters.brand.length) {
      updateAvailableOptions('models', selectedFilters.brand, 'cars');
    }
    updateCheckboxCounts();
    updateURL(selectedFilters);

    visibleCount = ITEMS_PER_PAGE;
    applyLoadMore();
    hideLoader();
  };

  const removeFilter = (group, value) => {
    const groupElement = document.getElementById(group + 's');
    if (!groupElement) return;
    const input = groupElement.querySelector(`input[value="${value}"]`);
    if (input) {
      input.checked = false;
    }
    updateFilters();
  };

  const resetFilters = () => {
    [modelsGroup, designsGroup, colorsGroup, brandsGroup].forEach(group => {
      group.querySelectorAll('input').forEach(input => input.checked = false);
    });
    updateFilters();
  };

  const updateAvailableOptions = (groupId, selectedBrands, filterAttribute) => {
    const group = document.getElementById(groupId);
    const items = group.querySelectorAll('input');
    const filteredBrandItems = getFilteredItemsByBrand(selectedBrands);
    const counts = {};
    filteredBrandItems.forEach(item => {
      const filterValues = item.dataset[filterAttribute]?.split(',') || [];
      filterValues.map(value => value.trim()).filter(Boolean).forEach(value => {
        counts[value] = (counts[value] || 0) + 1;
      });
    });
    items.forEach(input => {
      const count = counts[input.value] || 0;
      updateLabelCount(input.closest('label'), count);
      if (groupId === 'designs' || groupId === 'colors') {
        input.closest('label').style.display = count > 0 ? '' : 'none';
        input.disabled = count === 0;
      } else {
        input.disabled = count === 0;
        input.closest('label').style.display = count > 0 ? '' : 'none';
      }
    });
  };

  const getFilteredItemsByBrand = (selectedBrands) => {
    return [...galleryItems].filter(item => {
      return selectedBrands.length === 0 || selectedBrands.some(brand => item.dataset.brand?.split(',').includes(brand));
    });
  };

  // --- Refresh: called after background fetch adds more products ---
  function refresh() {
    galleryItems = document.querySelectorAll('.gallery__grid_item');

    populateCheckboxGroup(brandsGroup, uniqueValues('brand'), 'brand');
    populateCheckboxGroup(modelsGroup, uniqueValues('cars'), 'cars');
    populateCheckboxGroup(designsGroup, uniqueValues('design'), 'design');
    populateCheckboxGroup(colorsGroup, uniqueValues('color'), 'color');

    enforceSingleSelection(brandsGroup);
    enforceSingleSelection(modelsGroup);

    loadFiltersFromURL();
    updateFilters();
  }

  // --- Initial setup ---
  populateCheckboxGroup(brandsGroup, uniqueValues('brand'), 'brand');
  populateCheckboxGroup(modelsGroup, uniqueValues('cars'), 'cars');
  populateCheckboxGroup(designsGroup, uniqueValues('design'), 'design');
  populateCheckboxGroup(colorsGroup, uniqueValues('color'), 'color');

  enforceSingleSelection(brandsGroup);
  enforceSingleSelection(modelsGroup);

  loadFiltersFromURL();
  setTimeout(updateCheckboxCounts, 10);
  updateCheckboxCounts();

  [brandsGroup, modelsGroup, designsGroup, colorsGroup].forEach(group => {
    group.addEventListener('change', updateFilters);
  });

  resetButton.addEventListener('click', resetFilters);

  updateFilters();
  initLightbox();

  return refresh;
}

let lazyObserver = null;

function initLazyLoading() {
  lazyObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        img.src = img.dataset.src;
        img.classList.remove("lazy-image");
        lazyObserver.unobserve(img);
      }
    });
  }, {
    rootMargin: '100px',
    threshold: 0.1
  });

  observeLazyImages();
}

function observeLazyImages() {
  if (!lazyObserver) return;
  document.querySelectorAll('img.lazy-image').forEach(img => lazyObserver.observe(img));
}

function initLightbox() {
  const overlay = document.createElement('div');
  overlay.className = 'lightbox-overlay';
  overlay.innerHTML = `
    <button class="lightbox-close" aria-label="Close">&times;</button>
    <button class="lightbox-prev" aria-label="Previous">&#8249;</button>
    <button class="lightbox-next" aria-label="Next">&#8250;</button>
    <div class="lightbox-content">
      <img class="lightbox-img" src="" alt="">
      <div class="lightbox-caption"></div>
    </div>
  `;
  document.body.appendChild(overlay);

  const img = overlay.querySelector('.lightbox-img');
  const caption = overlay.querySelector('.lightbox-caption');
  const btnClose = overlay.querySelector('.lightbox-close');
  const btnPrev = overlay.querySelector('.lightbox-prev');
  const btnNext = overlay.querySelector('.lightbox-next');

  let items = [];
  let currentIndex = 0;

  function getVisibleItems() {
    return [...document.querySelectorAll('.gallery__grid_item.visible')];
  }

  function show(index) {
    items = getVisibleItems();
    if (!items.length) return;
    currentIndex = (index + items.length) % items.length;
    const item = items[currentIndex];
    img.src = item.href;

    // Reset zoom and pan when changing images
    currentScale = 1;
    panX = 0;
    panY = 0;
    applyTransform();

    // Clear caption and create new button
    caption.innerHTML = '';

    // Get product URL from data attribute
    const productUrl = item.getAttribute('data-product-url') ||
      item.getAttribute('data-variant-url') ||
      item.dataset.productUrl ||
      item.dataset.variantUrl ||
      '#';

    // Create a properly styled button
    const button = document.createElement('a');
    button.href = productUrl;
    button.target = '_blank';
    button.textContent = 'View Product';
    button.style.cssText = `
      display: inline-block;
      padding: 8px 20px;
      background-color: #ee3d48;
      color: #fff;
      border: 2px solid #ee3d48;
      border-radius: 8px;
      text-decoration: none;
      font-weight: 700;
      font-size: 14px;
      transition: all 0.2s ease-in-out;
      cursor: pointer;
    `;

    // Add hover effect
    button.addEventListener('mouseenter', function () {
      this.style.backgroundColor = 'rgb(240, 80, 90)';
      this.style.borderColor = 'rgb(240, 80, 90)';
    });
    button.addEventListener('mouseleave', function () {
      this.style.backgroundColor = '#ee3d48';
      this.style.borderColor = '#ee3d48';
    });

    caption.appendChild(button);

    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function hide() {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
    img.src = '';
    // Reset zoom and pan when closing
    currentScale = 1;
    panX = 0;
    panY = 0;
    applyTransform();
  }

  function next() { show(currentIndex + 1); }
  function prev() { show(currentIndex - 1); }

  document.addEventListener('click', (e) => {
    const item = e.target.closest('.gallery__grid_item');
    if (item) {
      e.preventDefault();
      items = getVisibleItems();
      const idx = items.indexOf(item);
      if (idx !== -1) show(idx);
    }
  });

  btnClose.addEventListener('click', hide);
  btnPrev.addEventListener('click', prev);
  btnNext.addEventListener('click', next);

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) hide();
  });

  document.addEventListener('keydown', (e) => {
    if (!overlay.classList.contains('active')) return;
    if (e.key === 'Escape') hide();
    if (e.key === 'ArrowRight') next();
    if (e.key === 'ArrowLeft') prev();
  });

  // Touch gesture support: swipe navigation, pinch-to-zoom, and pan when zoomed
  let touchStartX = 0;
  let touchStartY = 0;
  let touchEndX = 0;
  let touchEndY = 0;

  // Pinch-to-zoom variables
  let initialDistance = 0;
  let currentScale = 1;
  let isPinching = false;

  // Pan variables (for moving zoomed image)
  let panX = 0;
  let panY = 0;
  let lastTouchX = 0;
  let lastTouchY = 0;
  let isPanning = false;

  function getDistance(touch1, touch2) {
    const dx = touch2.clientX - touch1.clientX;
    const dy = touch2.clientY - touch1.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function applyTransform() {
    img.style.transform = `translate(${panX}px, ${panY}px) scale(${currentScale})`;
  }

  overlay.addEventListener('touchstart', (e) => {
    if (!overlay.classList.contains('active')) return;

    // Check if it's a pinch gesture (2 fingers)
    if (e.touches.length === 2) {
      isPinching = true;
      isPanning = false;
      initialDistance = getDistance(e.touches[0], e.touches[1]);
      e.preventDefault();
    } else if (e.touches.length === 1) {
      isPinching = false;

      // If zoomed in, enable panning instead of swiping
      if (currentScale > 1) {
        isPanning = true;
        lastTouchX = e.touches[0].clientX;
        lastTouchY = e.touches[0].clientY;
        e.preventDefault();
      } else {
        // At default zoom, enable swipe navigation
        isPanning = false;
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
      }
    }
  }, { passive: false });

  overlay.addEventListener('touchmove', (e) => {
    if (!overlay.classList.contains('active')) return;

    // Handle pinch-to-zoom (2 fingers)
    if (e.touches.length === 2 && isPinching) {
      e.preventDefault();
      e.stopPropagation();

      const currentDistance = getDistance(e.touches[0], e.touches[1]);
      const scale = currentDistance / initialDistance;

      // Apply scale with limits (0.5x to 4x zoom)
      currentScale = Math.max(0.5, Math.min(4, currentScale * scale));
      applyTransform();

      // Update initial distance for smooth continuous pinching
      initialDistance = currentDistance;
    }
    // Handle panning when zoomed in (1 finger)
    else if (e.touches.length === 1 && isPanning) {
      e.preventDefault();
      e.stopPropagation();

      const currentTouchX = e.touches[0].clientX;
      const currentTouchY = e.touches[0].clientY;

      // Calculate movement delta
      const deltaX = currentTouchX - lastTouchX;
      const deltaY = currentTouchY - lastTouchY;

      // Update pan position
      panX += deltaX;
      panY += deltaY;

      // Apply transform with current pan and scale
      applyTransform();

      // Update last touch position for next move event
      lastTouchX = currentTouchX;
      lastTouchY = currentTouchY;
    }
    // Handle swipe detection (1 finger, not zoomed)
    else if (e.touches.length === 1 && !isPinching && !isPanning) {
      e.stopPropagation();
    }
  }, { passive: false });

  overlay.addEventListener('touchend', (e) => {
    if (!overlay.classList.contains('active')) return;

    // Only handle swipe if it wasn't a pinch or pan gesture
    if (!isPinching && !isPanning && e.touches.length === 0) {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      handleSwipe();
    }

    // Reset gesture states when all fingers are lifted
    if (e.touches.length === 0) {
      isPinching = false;
      isPanning = false;
    }
  }, { passive: false });

  function handleSwipe() {
    const deltaX = touchEndX - touchStartX;
    const deltaY = touchEndY - touchStartY;
    const minSwipeDistance = 50;

    // Only trigger if horizontal swipe is greater than vertical (prevent interfering with scroll)
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance) {
      if (deltaX > 0) {
        // Swiped right - go to previous
        prev();
      } else {
        // Swiped left - go to next
        next();
      }
    }
  }
}


// ===== MAIN: Two-phase loading =====
// This IIFE is at the bottom so all functions above are defined
(async () => {
  // PHASE 1: Show Liquid-rendered items instantly (no fetch needed)
  createLoadMoreButton();
  initLazyLoading();
  var refresh = initFilter();

  // PHASE 2: Fetch all products in background, then update filters silently
  var products = await fetchAllProductsFromCollection('wheels-1');
  if (products) {
    // Remove Liquid-rendered items to avoid duplicates (fetched set includes all pages)
    var gallery = document.querySelector('.gallery__grid');
    if (gallery) {
      gallery.querySelectorAll('.gallery__grid_item').forEach(function (el) { el.remove(); });
    }
    renderGallery(products);
    observeLazyImages();
    refresh();
  }
})();
